import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from 'next/image';
import Error from '/public/images/errors/403.png';

export default function Error403(){
    return (
         
    <div className={`${PageStyle.NewJob}`}>
      
    <div className={PageStyle.NewJob__Container}>
      <div className={`${PageStyle.Error} ${PageStyle.ErrorAlign}`}>
      <Image src='/images/errors/403.png' height={217} width={291} alt=''></Image>

          <h1>Authentication Error</h1>

          <h4 className={`mb0 mt0 ${PageStyle.mw95}`}>The current user doesn't have permission to view this page. <br/> Please login with the a different user to access the page.</h4>

{/*           <p>Duis a nisl dolor. Integer a gravida ligula. Phasellus finibus risus ac orci venenatis pretium. Duis a imperdiet justo, sagittis volutpat tortor. </p>
 */}      </div>
      </div></div>
    )
}